import { render, staticRenderFns } from "./ShareDraw.vue?vue&type=template&id=1f63c994&scoped=true"
import script from "./ShareDraw.vue?vue&type=script&lang=js"
export * from "./ShareDraw.vue?vue&type=script&lang=js"
import style0 from "./ShareDraw.vue?vue&type=style&index=0&id=1f63c994&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f63c994",
  null
  
)

export default component.exports